import gsap from "gsap";

document.addEventListener("DOMContentLoaded", function () {
    // console.log('Menu init');
    let button = document.querySelector('#header-menu-button');
    let isopen = false;

    let elem = document.querySelector('#menu-mobile');

    let closeIcon = document.querySelector('#js-menu-close-icon');
    let openIcon = document.querySelector('#js-menu-open-icon');

    button.addEventListener('click', function () {
        let set = !isopen;
        if(set) {
            // Открываем меню
            gsap.fromTo( elem, {opacity: 0, y: '-10%'}, {opacity: 1, y: '0%', onStart:()=>{elem.style.display='block'}, onComplete: ()=>{}});
            // Меняем иконку
            gsap.fromTo(openIcon, {opacity: 1}, {opacity: 0});
            gsap.fromTo(closeIcon,{opacity: 0}, {opacity: 1});
            

            // Удаляем соцсети
            gsap.fromTo('.js-menu-remove-on-open', {opacity: 1, x: '0%'}, {opacity: 0, x: '0%'});

        } else {
            // Закрываем меню
            gsap.fromTo( elem, {opacity: 1, y: '0%'}, {opacity: 0, y: '-10%', onStart:()=>{}, onComplete: ()=>{elem.style.display='none'}});

            // Меняем иконку
            gsap.fromTo(closeIcon, {opacity: 1}, {opacity: 0});
            gsap.fromTo(openIcon,  {opacity: 0}, {opacity: 1});

            // Показыаем соцсети
            gsap.fromTo('.js-menu-remove-on-open', {opacity: 0, x: '0%'}, {opacity: 1, x: '0%'});
        }
        isopen = set;
    });
  
});